import React, { useEffect, useState } from 'react'
import { Button } from "flowbite-react";
import axios from 'axios';
import LoadingSpinner from '../../components/LoadingSpinner';

const FormUser = ({ userId, onSubmit , onClose }) => {
    const [formData, setFormData] = useState({
        "name" : "",
        "email" : "",
        "password" : "",
        "status" : ""
    });
    const [isLoading, setIsLoading] = useState(false);

    const [passwordShow, setPasswordShow] = useState("mb-5");

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };
    
    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(formData);
    };

    
    useEffect(()=>{
        if (userId) {
            getUser();
        }
    },[userId])

    const getUser = async () => {
        setIsLoading(true);
        try {
            const user = await axios.get(
                `${((import.meta.env.VITE_ENV=='development')?import.meta.env.VITE_BACKEND_LOCAL:import.meta.env.VITE_BACKEND)}/users/${userId}`,
                {
                    withCredentials: true,
                }
            );

            setFormData(user.data);
            setPasswordShow("mb-5 hidden");

        } catch (error) {
            
        } finally{
            setIsLoading(false);
        } 
    }

    return (
    <>
        {isLoading && <LoadingSpinner message="Procesando..." size="lg" color="blue"/>}
        <form onSubmit={handleSubmit} className="space-y-4 max-w-sm mx-auto">
            <div className="mb-5">
                <label htmlFor="name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Usuario</label>
                <input type="text" 
                name="name" 
                id="name" 
                value={formData.name}
                onChange={handleChange}
                aria-describedby="helper-text-explanation" 
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" 
                placeholder="Ingrese el nombre del usuario" />
            </div>
            <div className="mb-5">
                <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Email</label>
                <input type="text" 
                name="email" 
                id="email" 
                value={formData.email}
                onChange={handleChange}
                aria-describedby="helper-text-explanation" 
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" 
                placeholder="Ingrese el email" />
            </div>

            <div className={passwordShow}>
                <label htmlFor="password" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Password</label>
                <input type="password" 
                name="password" 
                id="password" 
                value={formData.password}
                onChange={handleChange}
                aria-describedby="helper-text-explanation" 
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" 
                placeholder="Ingrese la password" />
            </div>

            <div className="mb-5">
                <label htmlFor="status" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Estado</label>
                <select  
                    name="status" 
                    id="status" 
                    value={formData.status}
                    onChange={handleChange}
                    aria-describedby="helper-text-explanation" 
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" 
                    >
                        <option value="">Seleccione Estado</option>
                        <option value="0">Inactivo</option>
                        <option value="1">Activo</option>
                    </select>

            </div>

            <div className="mb-5 flex">
                <Button color="gray" onClose={onClose} className='mr-3'>
                    Cancelar
                </Button>
                <Button type='submit' className="" color="gray">Guardar</Button>
            </div>
        </form>
    </>
    )
}

export default FormUser
